/* hero-video-gate.js (stable)
   - Prevents loading BOTH hero videos.
   - Avoids repeated reload/play glitches.
   - Only re-gates when breakpoint actually changes.
   Supports:
   A) Shopify video_tag output (<source data-src="..." src="...">)
   B) Placeholder desktop (<video data-video-src="..."></video>)
*/

(function () {
  var MQ_DESKTOP = "(min-width: 750px)";
  var lastMode = null; // "desktop" or "mobile"

  function mode() {
    return window.matchMedia(MQ_DESKTOP).matches ? "desktop" : "mobile";
  }

  function getDesktopVideos() {
    return Array.prototype.slice.call(
      document.querySelectorAll('[data-hero-video="desktop"] video, video.hero-video--desktop')
    );
  }

  function getMobileVideos() {
    return Array.prototype.slice.call(
      document.querySelectorAll('[data-hero-video="mobile"] video')
    );
  }

  // --- Placeholder videos (data-video-src) ---
  function enablePlaceholder(video) {
    if (!video) return;

    // Only do work once
    if (video.dataset.gatedEnabled === "1") return;

    var src = video.getAttribute("data-video-src");
    if (!src) return;

    // Inject one <source> only once
    if (!video.querySelector("source")) {
      var s = document.createElement("source");
      s.src = src;
      s.type = "video/mp4";
      video.appendChild(s);
    }

    video.dataset.gatedEnabled = "1";
    video.dataset.gatedDisabled = "0";
    // Let browser handle playback naturally; no forced load/play spam
  }

  function disablePlaceholder(video) {
    if (!video) return;

    // Only do work once
    if (video.dataset.gatedDisabled === "1") return;

    try { video.pause(); } catch (e) {}

    // Remove injected sources
    video.querySelectorAll("source").forEach(function (s) { s.remove(); });

    video.dataset.gatedDisabled = "1";
    video.dataset.gatedEnabled = "0";
  }

  // --- Shopify video_tag videos (<source data-src + src>) ---
  function enableShopify(video) {
    if (!video) return;
    if (video.dataset.gatedEnabled === "1") return;

    video.querySelectorAll("source").forEach(function (s) {
      // Ensure backup
      if (!s.dataset.src && s.getAttribute("src")) {
        s.dataset.src = s.getAttribute("src");
      }
      // Restore from data-src if needed
      if (!s.getAttribute("src") && s.dataset.src) {
        s.setAttribute("src", s.dataset.src);
      }
    });

    video.dataset.gatedEnabled = "1";
    video.dataset.gatedDisabled = "0";
    // Do NOT call video.load()/play() here to avoid glitches
  }

  function disableShopify(video) {
    if (!video) return;
    if (video.dataset.gatedDisabled === "1") return;

    try { video.pause(); } catch (e) {}

    video.querySelectorAll("source").forEach(function (s) {
      // Ensure backup
      if (!s.dataset.src && s.getAttribute("src")) {
        s.dataset.src = s.getAttribute("src");
      }
      s.removeAttribute("src");
    });

    video.dataset.gatedDisabled = "1";
    video.dataset.gatedEnabled = "0";
  }

  function isPlaceholder(video) {
    return !!video && !!video.getAttribute("data-video-src");
  }

  function enable(video) {
    return isPlaceholder(video) ? enablePlaceholder(video) : enableShopify(video);
  }

  function disable(video) {
    return isPlaceholder(video) ? disablePlaceholder(video) : disableShopify(video);
  }

  function gate(force) {
    var m = mode();

    // Only act if mode changed (prevents repeated requests + reload glitches)
    if (!force && m === lastMode) return;
    lastMode = m;

    var desktopVideos = getDesktopVideos();
    var mobileVideos = getMobileVideos();

    // If hero isn't on this page, exit
    if (!desktopVideos.length && !mobileVideos.length) return;

    if (m === "desktop") {
      desktopVideos.forEach(enable);
      mobileVideos.forEach(disable);
    } else {
      mobileVideos.forEach(enable);
      desktopVideos.forEach(disable);
    }
  }

  // Run once when DOM is ready (markup exists)
  document.addEventListener("DOMContentLoaded", function () {
    gate(true);

    // One extra delayed run to catch late slider init—BUT only if needed
    setTimeout(function () { gate(false); }, 300);
  });

  // Only re-gate when the breakpoint changes
  window.matchMedia(MQ_DESKTOP).addEventListener("change", function () {
    gate(true);
  });
})();
